import React from 'react'

export default function NotAvailable() {
  return (
    <h1 className="not-available">
        Ooops.....! Looks like no Movie available for the selected Genre.
    </h1>
  )
}
